<template>
    <v-dialog :value="dialog" width="95%">
        <v-card>
            <v-card-title
                    class="blue-grey darken-1 py-4 title"
            >
                Abonnement {{key === null ? 'maken' : 'aanpassen'}}
            </v-card-title>
            <v-container grid-list-sm class="pa-4">
                <v-stepper v-model="stepper">
                    <v-stepper-header>
                        <v-stepper-step :complete="stepper > 1" step="1" editable>Gegevens</v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step :complete="stepper > 2" step="2" editable>Tribune</v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step step="3" :editable="tribune != null && tribuneObject != null && tribuneObject.type === 'sit'">Plaats</v-stepper-step>
                    </v-stepper-header>
                    <v-stepper-items>
                        <v-stepper-content step="1">
                            <v-layout row wrap>
                                <v-flex xs6 align-center justify-space-between>
                                    <v-layout align-center>
                                        <v-text-field
                                                label="Voornaam"
                                                v-model="firstName"
                                        ></v-text-field>
                                    </v-layout>
                                </v-flex>
                                <v-flex xs6 align-center justify-space-between>
                                    <v-layout align-center>
                                        <v-text-field
                                                label="Achternaam"
                                                v-model="lastName"
                                        ></v-text-field>
                                    </v-layout>
                                </v-flex>
                                <v-flex xs12 align-center justify-space-between>
                                    <v-layout align-center>
                                        <v-text-field
                                                label="Straat & nummer"
                                                v-model="street"
                                        ></v-text-field>
                                    </v-layout>
                                </v-flex>
                                <v-flex xs6 align-center justify-space-between>
                                    <v-layout align-center>
                                        <v-text-field
                                                label="Postcode"
                                                v-model="postalCode"
                                        ></v-text-field>
                                    </v-layout>
                                </v-flex>
                                <v-flex xs6 align-center justify-space-between>
                                    <v-layout align-center>
                                        <v-text-field
                                                label="Gemeente"
                                                v-model="city"
                                        ></v-text-field>
                                    </v-layout>
                                </v-flex>

                                <v-flex xs9 align-center justify-space-between>
                                    <v-layout align-center>
                                        <v-text-field
                                                label="Tribune plaats"
                                                v-model="seatPresentation"
                                                readonly
                                                solo
                                        ></v-text-field>
                                    </v-layout>
                                </v-flex>
                                <v-flex xs3 align-bottom justify-space-between>
                                    <v-layout align-right>
                                        <v-btn large flat @click="stepper = 2">Plaats kiezen</v-btn>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-stepper-content>

                        <v-stepper-content step="2">
                            <Tribunes
                                    v-on:tribuneSelected="(tribune, price) => { setSelectedTribune(tribune, price); }"
                                    :selectedTribuneKey="tribune"
                                    :selectedTribunePrice="tribunePrice"
                            ></Tribunes>
                        </v-stepper-content>

                        <v-stepper-content step="3">
                            <seat-selection
                                    :selectedTribuneKey="tribune"
                                    :selectedTribune="tribuneObject"
                                    :reservedSeats="reservedSeats"
                                    :selectedSeat="tribuneSeat"
                                    selectedSeats="selectedSeats"
                                    v-on:seatSelected="(rownr, seat) => { setSelectedSeat(rownr, seat)}"
                            ></seat-selection>
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>

            </v-container>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="closeDialog">Cancel</v-btn>
                <template v-if="key === null">
                    <v-btn flat dark @click="addSubscription">Aanmaken</v-btn>
                </template>
                <template v-else>
                    <v-btn flat dark @click="editSubscription">Aanpassingen opslaan</v-btn>
                </template>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { _ } from "vue-underscore";
import { db } from "../../firebase";
import TribuneSelectionDialog from "./Tribunes";
import Tribunes from "../components/Tribunes";
import SeatSelection from "./SeatSelection";
export default {
  name: "SubscriptionDialog",
  components: { SeatSelection, Tribunes, TribuneSelectionDialog },
  props: {
    dialog: Boolean,
    selectedSubscription: Object
  },
  data: function() {
    return {
      key: null,
      firstName: "",
      lastName: "",
      street: "",
      postalCode: "",
      city: "",
      tribune: "",
      tribunePrice: "",
      tribuneBlock: "",
      tribuneObject: null,
      tribuneRow: null,
      tribuneSeat: null,
      stepper: 1,
      reservedSeats: [],
      selectedSeats: []
    };
  },
  watch: {
    selectedSubscription: function(newVal) {
      if (newVal !== null) {
        this.key = newVal[".key"];
        this.firstName = newVal.firstName;
        this.lastName = newVal.lastName;
        this.street = newVal.street;
        this.postalCode = newVal.postalCode;
        this.city = newVal.city;
        this.tribune = newVal.tribune;
        this.tribunePrice = newVal.tribunePrice;
        this.tribuneBlock = newVal.tribuneBlock;
        this.tribuneRow = newVal.tribuneRow;
        this.tribuneSeat = newVal.tribuneSeat;
        this.setReservedSeats(this.tribune);
      } else {
        this.resetData();
      }
    },
    tribune: function(newVal) {
      if (newVal !== null && newVal !== "") {
        if (!this.tribuneObject) {
          this.fetchTribune(newVal);
        }
        this.setReservedSeats(newVal);
      }
    }
  },
  computed: {
    seatPresentation: function() {
      let tribunePrice = "";
      if (this.tribunePrice) {
        tribunePrice = " (" + this.tribunePrice + ")";
      }
      if (this.tribuneRow && this.tribuneSeat) {
        return (
          this.tribuneBlock + " " + this.tribuneRow + "/" + this.tribuneSeat + tribunePrice
        );
      } else if (this.tribuneSeat) {
        return this.tribuneBlock + " " + this.tribuneSeat + tribunePrice;
      }

      return "";
    }
  },
  methods: {
    fetchTribune: function(tribuneKey) {
      db.collection("tribunes")
        .doc(tribuneKey)
        .get()
        .then(tribune => {
          this.tribuneObject = tribune.data();
        });
    },
    setReservedSeats: function(tribuneKey, tribuneType, setSeat, places) {
      this.reservedSeats = [];
      db.collection("subscriptions")
        .where("tribune", "==", tribuneKey)
        .get()
        .then(subscriptions => {
          subscriptions.forEach(subscription => {
            this.reservedSeats.push(subscription.data().tribuneSeat);
          });
          if (tribuneType === "stand" && setSeat === true) {
            this.tribuneRow = 0;
            if (this.reservedSeats.length > 0) {
              const allAvailableSeats = [..._.range(1, places + 1, +1)];
              this.reservedSeats.forEach(seat => {
                const index = allAvailableSeats.indexOf(seat);
                if (index > -1) {
                  allAvailableSeats.splice(index, 1);
                }
              });
              this.tribuneSeat = allAvailableSeats[0];
            } else {
              this.tribuneSeat = 1;
            }
          }
        });
    },
    setSelectedTribune: function(tribune, tribunePrice) {
      this.tribuneObject = tribune;
      this.tribune = tribune[".key"];
      this.tribunePrice = tribunePrice;
      this.setReservedSeats(this.tribune, tribune.type, true, tribune.places);
      if (tribune.type === "sit") {
        this.stepper = 3;
      } else {
        this.stepper = 1;
      }
    },
    setSelectedSeat: function(rownr, seat) {
      this.tribuneRow = rownr;
      this.tribuneSeat = seat;
    },
    resetData: function() {
      this.key = null;
      this.firstName = "";
      this.lastName = "";
      this.street = "";
      this.postalCode = "";
      this.city = "";
      this.tribune = "";
      this.tribunePrice = "";
      this.tribuneBlock = "";
      this.tribuneObject = null;
      this.tribuneRow = null;
      this.tribuneSeat = null;
      this.stepper = 1;
      this.reservedSeats = [];
    },
    closeDialog: function() {
      this.$emit("closeDialog", true);
      this.resetData();
    },
    addSubscription: function() {
      db.collection("subscriptions").add(this.buildSubscriptionData());
      this.closeDialog();
    },
    editSubscription: function() {
      db.collection("subscriptions")
        .doc(this.key)
        .set(this.buildSubscriptionData(true));
      this.closeDialog();
    },
    buildSubscriptionData(update = false) {
      const subscription = {
        firstName: this.firstName,
        lastName: this.lastName,
        street: this.street,
        postalCode: this.postalCode,
        city: this.city,
        tribuneRow: this.tribuneRow,
        tribuneSeat: this.tribuneSeat,
        tribunePrice: this.tribunePrice
      };
      if (!update) {
        subscription.tribune = this.tribuneObject
          ? this.tribuneObject[".key"]
          : null;
        subscription.tribuneBlock = this.tribuneObject
          ? this.tribuneObject.block
          : null;
        subscription.timestamp = new Date();
      } else {
        if (
          this.tribuneObject &&
          this.tribuneObject[".key"] !== subscription.tribune
        ) {
          subscription.tribune = this.tribuneObject[".key"];
          subscription.tribuneBlock = this.tribuneObject.block;
        } else {
          subscription.tribune = this.tribune;
          subscription.tribuneBlock = this.tribuneBlock;
        }
        subscription.updated = new Date();
      }

      return subscription;
    }
  }
};
</script>
